let pending_pill_filters = {
          All: {name: 'All', display: 'All', is_active: 1, is_visible: true, count: 0},
          Pending: {name: 'Pending', display: 'Pending', is_active: 0, is_visible: true, count: 0},
          Inprogress: {name: 'Inprogress', display: 'In Progress', is_active: 0, is_visible: true, count: 0},
          Awaiting: {name: 'Awaiting', display: 'For Approval', is_active: 0, is_visible: true, count: 0}
}

module.exports = pending_pill_filters